<template>
  <div class="min-w-125px w-auto">
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center gap-1">
        <b-avatar
          :text="[comment.commenter.first_name, comment.commenter.last_name].map(name => String(name).charAt(0)).join('')"
          size="30px"
        />
        <div
          class="d-flex flex-column justify-content-between p-1"
        >
          <div class="font-weight-bold">
            {{ comment.commenter.first_name }} {{ comment.commenter.last_name }}
          </div>

          <div
            class="pb-0"
            style="font-size: 10px;"
          >
            {{ dateTime }} <b>{{ moment(comment.updated_at).diff(moment(comment.created_at), 'seconds') > 0 ? '- Edited' : '' }}</b>
          </div>
        </div>
      </div>

      <b-card
        body-class="py-2 px-2"
        :class="[
          'border', {
            'border-secondary': String(reply) === String(comment.id)
          }
        ]"
        :style="{
          borderBottomLeftRadius: '24px',
          borderBottomRightRadius: '24px',
          borderTopRightRadius: '24px',
          backgroundColor: '#f2f2f2',
        }"
      >

        <div
          v-if="repliedComment"
          class="bg-light px-2 py-1 mb-2 mx--1 mt--1 cursor-pointer"
          style="border-top-right-radius: 20px;"
          @click.prevent.stop="() => scrollToComment(comment.thread_id)"
        >
          <div class="font-weight-bold">
            {{ repliedComment?.commenter?.first_name }} {{ repliedComment?.commenter?.last_name }}
          </div>

          <div class="text-truncate">
            {{ repliedComment?.comment }}
          </div>
        </div>

        <div
          v-if="String(reply) === String(comment.id)"
          class="bg-light p-2 mb-2 mx--1 mt--1"
          :style="repliedComment ? {} : { borderTopRightRadius: '20px' }"
        >
          <q>Quoted on Reply</q>
        </div>

        <b-card-text
          v-b-toggle="`collapse-${comment.id}`"
          class="cursor-pointer"
        >
          <div class="d-flex flex-column">
            <div
              class="p-1"
              style="white-space: pre-wrap;"
            >
              {{ comment.comment }}
            </div>
          </div>
        </b-card-text>
      </b-card>

      <b-collapse
        :id="`collapse-${comment.id}`"
      >
        <div class="d-flex gap-2 mt-1 align-items-center justify-content-end px-3">
          <b-button
            size="xs"
            variant="link"
            class="p-0 text-dark"
            :disabled="busy"
            @click.prevent.stop="() => $emit('reply:comment', comment)"
          >
            <i class="ri-reply-line m-0 p-0" /> Reply
          </b-button>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'

import MxFormatter from '@/mixins/formatter'

export default {
  name: 'OtherComment',

  emit: [
    'reply:comment'
  ],

  mixins: [
    MxFormatter
  ],

  props: {
    busy: {
      type: Boolean,
      required: true
    },
    comment: {
      type: Object,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
    reply: {
      type: [Number, String],
      required: false,
      default: () => ''
    }
  },

  computed: {
    dateTime () {
      const now = moment()
      const createdAt = moment(this.comment.created_at)
      const diffInMinutes = now.diff(createdAt, 'minutes')

      if (diffInMinutes < 1) {
        return 'Just now'
      }

      if (diffInMinutes < 15) {
        return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`
      }

      if (now.isSame(createdAt, 'day')) {
        return `Today at ${createdAt.format('h:mm A')}`
      }

      return createdAt.format('MMMM D, YYYY h:mm A')
    },

    repliedComment () {
      return find(this.comments, {
        id: this.comment.thread_id
      })
    }
  },

  methods: {
    moment: moment,

    scrollToComment (id) {
      const element = document.getElementById(`comment-${id}`)

      const scrollArea = document.getElementById('comment-scroll-area')
      if (scrollArea) {
        scrollArea.scrollTo({
          top: element.offsetTop - 150,
          behavior: 'smooth'
        })

        element.classList.add('animated', 'pulse', 'border', 'border-dark', 'rounded-lg')

        setTimeout(() => {
          element.classList.remove('animated', 'pulse', 'border', 'border-dark', 'rounded-lg')
        }, 1500)
      }
    }
  }
}
</script>
